<!-- Header -->
<overlay-header [showCloseButton]="true" (closeClick)="closeClick()" *ngIf="isOverlay">
    Student Details
</overlay-header>

<tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">
    <div class="flex-header">
        <student-header [useParentPortalYear]="true" [pageTitle]="(isOverlay) ? '' : 'Student Details'"
            [showYearSelector]="true" [disableYearSelect]="true"></student-header>
    </div>
    <div class="flex-content" style="padding-left: 10px; flex:1;">
        <b style="font-size: 12pt; color:#3f51b5;">
            <span translate>Student Details</span>
        </b>
        <div style="height:5px;"></div>
        <div *ngIf="studentDetails" style="width:100%;">
            <table class="table">
                <tr>
                    <td style="width:33%;vertical-align:top;">
                        <div>
                            <table>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959; width:130px;"
                                        translate>
                                        Student #
                                    </td>
                                    <td style="line-height:25px;vertical-align:top;padding-left:5px;padding-right:5px;">
                                        {{studentDetails.StudentId}}</td>
                                </tr>
                                <tr
                                    *ngIf="(studentDetails.EnrollmentStatus != null && studentDetails.EnrollmentStatus != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:130px;"
                                        translate>
                                        Enrollment Status
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right: 5px;">
                                        {{studentDetails.EnrollmentStatus}}</td>
                                </tr>
                                <tr
                                    *ngIf="studentDetails.PrimaryCounselor != null && studentDetails.PrimaryCounselor != ''">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:130px;"
                                        translate>
                                        Primary Counselor
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right: 5px;">
                                        {{studentDetails.PrimaryCounselor}}</td>
                                </tr>
                                <tr
                                    *ngIf="(studentDetails.GraduationPlan != null && studentDetails.GraduationPlan != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:130px;"
                                        translate>
                                        Graduation Plan
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right: 5px;">
                                        {{studentDetails.GraduationPlan}}</td>
                                </tr>
                                <tr
                                    *ngIf="!loginSettings.DisplayReportCardTranscriptOnHold && (studentDetails.LivesWith != null && studentDetails.LivesWith != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        translate>
                                        Lives With
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px">
                                        {{studentDetails.LivesWith}}</td>
                                </tr>
                                <tr style="vertical-align:top;"
                                    *ngIf="((studentDetails.Bus != null && studentDetails.Bus != '') || (studentDetails.ReportCardTranscriptOnHold != null && studentDetails.ReportCardTranscriptOnHold != ''))">
                                    <td style="line-height:25px;color:#595959;width:130px;">
                                        <span *ngIf="loginSettings.DisplayBus" translate>
                                            Bus
                                        </span>
                                        <span
                                            *ngIf="loginSettings.DisplayReportCardTranscriptOnHold && studentDetails.ReportCardTranscriptOnHold != null && studentDetails.ReportCardTranscriptOnHold != ''">
                                            <span style="white-space: nowrap;" translate>
                                                Report Card/Transcript On Hold
                                            </span>
                                        </span>
                                    </td>
                                    <td
                                        style="line-height: 25px; padding-left: 5px; padding-right: 5px; vertical-align: bottom;">
                                        <span *ngIf="loginSettings.DisplayBus">{{studentDetails.Bus}}</span>
                                        <span
                                            *ngIf="loginSettings.DisplayReportCardTranscriptOnHold && studentDetails.ReportCardTranscriptOnHold != null && studentDetails.ReportCardTranscriptOnHold != ''">{{studentDetails.ReportCardTranscriptOnHold}}</span>
                                    </td>
                                </tr>
                                <tr style="vertical-align:top;"
                                    *ngIf="((currentUser.UserType == 1) && (studentDetails.TransportationComment != null && studentDetails.TransportationComment != ''))">
                                    <td style="line-height:25px;color:#595959;width:130px;">
                                        <span translate>
                                            Transportation Comment
                                        </span>
                                    </td>
                                    <td
                                        style="line-height: 25px; padding-left: 5px; padding-right: 5px; vertical-align: top;">
                                        <span>{{studentDetails.TransportationComment}}</span>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="loginSettings.DisplayCustodyIssue && (studentDetails.CustodyIssue != null && studentDetails.CustodyIssue != '')">
                                    <td style="line-height:25px;color:#595959;width:130px;vertical-align:top;"
                                        translate>
                                        Custody Issue
                                    </td>
                                    <td style="line-height:25px;vertical-align:top;padding-left: 5px;padding-right:5px">
                                        {{studentDetails.CustodyIssue}}</td>
                                </tr>
                                <tr *ngIf="currentUser.UserType == 1 && studentDetails.ShowStudentLogin">
                                    <td style="line-height:25px;color:#595959;width:130px;vertical-align:top;"
                                        translate>
                                        Student Login
                                    </td>
                                    <td style="line-height:25px;vertical-align:top;padding-left: 5px;padding-right:5px">
                                        <span *ngIf="studentLoginHidden">
                                            {{maskedLogin}}
                                        </span>
                                        <span *ngIf="!studentLoginHidden">
                                            {{studentDetails.StudentLogin}}
                                        </span>
                                        <tyl-button *ngIf="!studentLoginHidden" image="visibilityOff.png"
                                            [iconWidth]="20" (clickEvent)="studentLoginHidden = !studentLoginHidden">
                                        </tyl-button>
                                        <tyl-button *ngIf="studentLoginHidden" image="visibility.png" [iconWidth]="20"
                                            (clickEvent)="studentLoginHidden = !studentLoginHidden"></tyl-button>
                                    </td>
                                </tr>
                                <tr *ngIf="currentUser.UserType == 1 && studentDetails.ShowStudentPassword">
                                    <td style="line-height:25px;color:#595959;width:130px;vertical-align:top;"
                                        translate>
                                        Student Password
                                    </td>
                                    <td style="line-height:25px;vertical-align:top;padding-left: 5px;padding-right:5px">
                                        <span *ngIf="studentPasswordHidden">
                                            {{maskedPassword}}
                                        </span>
                                        <span *ngIf="!studentPasswordHidden">
                                            {{studentDetails.StudentPassword}}
                                        </span>
                                        <tyl-button *ngIf="!studentPasswordHidden" image="visibilityOff.png"
                                            [iconWidth]="20"
                                            (clickEvent)="studentPasswordHidden = !studentPasswordHidden">
                                        </tyl-button>
                                        <tyl-button *ngIf="studentPasswordHidden" image="visibility.png"
                                            [iconWidth]="20"
                                            (clickEvent)="studentPasswordHidden = !studentPasswordHidden"></tyl-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>
                    <td style="width:33%;vertical-align:top;">
                        <div>
                            <table>
                                <tr
                                    *ngIf="((currentUser.UserType == 1) && (studentDetails.CourtOrderId > 0 || studentDetails.CourtOrderAgainst != ''))">
                                    <td style="line-height:25px;vertical-align:top;width:140px;font-weight: 600;color: red"
                                        translate>
                                        Court Order
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;font-weight: 600;color: red;">
                                        {{studentDetails.CourtOrderAgainst}}</td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;">
                                        {{
                                        loginSettings.CountryCode == 'CAN' ? 'MET #' : ('State ID' | translate)
                                        }}
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right: 5px;">
                                        {{studentDetails.StudentStateIdentifier}}</td>
                                </tr>
                                <tr *ngIf="(studentDetails.CellPhone != null && studentDetails.CellPhone != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        translate>
                                        Cell Phone
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.CellPhone}}</td>
                                </tr>
                                <tr *ngIf="(studentDetails.EmailAddress != null && studentDetails.EmailAddress != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        translate>
                                        Email Address
                                    </td>
                                    <td *ngIf="this.currentUser.UserType == 1" class="link"
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px; color:#3f51b5"
                                        (click)="sendEmail(selectedStudent.FirstName + ' ' + selectedStudent.LastName,studentDetails.EmailAddress)">
                                        {{studentDetails.EmailAddress}}
                                    </td>
                                    <td *ngIf="this.currentUser.UserType != 1"
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.EmailAddress}}
                                    </td>
                                </tr>
                                <tr *ngIf="(studentDetails.Locker != null && studentDetails.Locker != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        *ngIf="!loginSettings.DisplayReportCardTranscriptOnHold || (studentDetails.Locker != null && studentDetails.Locker != '')"
                                        translate>
                                        Locker #
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.Locker}}</td>
                                </tr>
                                <tr
                                    *ngIf="(studentDetails.LockerCombination != null && studentDetails.LockerCombination != '')">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        *ngIf="!loginSettings.DisplayReportCardTranscriptOnHold || (studentDetails.LockerCombination != null && studentDetails.LockerCombination != '')"
                                        translate>
                                        Locker Combination
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <span *ngIf="!lockerComboHidden">
                                            {{studentDetails.LockerCombination}}
                                        </span>
                                        <span *ngIf="lockerComboHidden">
                                            {{maskedLocker}}
                                        </span>
                                        <tyl-button *ngIf="!lockerComboHidden" image="visibilityOff.png"
                                            [iconWidth]="20" (clickEvent)="lockerComboHidden = !lockerComboHidden">
                                        </tyl-button>
                                        <tyl-button *ngIf="lockerComboHidden" image="visibility.png" [iconWidth]="20"
                                            (clickEvent)="lockerComboHidden = !lockerComboHidden"></tyl-button>
                                    </td>
                                </tr>
                                <tr *ngIf="(schools != null && schools != [])">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        translate>
                                        Dual Enrolled
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <div style="display: flex;flex-direction: column;"
                                            *ngFor="let school of schools; let i = index">
                                            <span>
                                                {{school}}
                                            </span>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:140px;"
                                        *ngIf="studentDetails.IEPCaseManager != null && studentDetails.IEPCaseManager != ''"
                                        translate>
                                        IEP Case Manager
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.IEPCaseManager}}</td>
                                </tr>
                            </table>
                        </div>
                    </td>
                    <td style="width:33%;vertical-align:top;">
                        <div>
                            <table>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        translate>
                                        Gender
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.Gender}}
                                        <span style="padding-left: 5px;" *ngIf="enableGenderPronouns"
                                            class="disabledText">
                                            {{studentDetails.PreferedPronouns}}
                                        </span>
                                    </td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        translate>
                                        Age
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.Age}}</td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        *ngIf="!loginSettings.DisplayReportCardTranscriptOnHold || (studentDetails.Ethnicity != null && studentDetails.Ethnicity != '')"
                                        translate>
                                        Ethnicity
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.Ethnicity}}</td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        *ngIf="!loginSettings.DisplayReportCardTranscriptOnHold || (studentDetails.Race != null && studentDetails.Race != '')"
                                        translate>
                                        Race
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        {{studentDetails.Race}}</td>
                                </tr>
                                <tr>
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:100px;"
                                        translate>
                                        Birth Date
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <span>{{studentDetails.BirthDate|date:'MM/dd/yy'}}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="studentDetails.PrimaryLanguage">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:183px;"
                                        translate>
                                        Language Spoken at Home
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <span>{{studentDetails.PrimaryLanguage}}</span>
                                    </td>
                                </tr>
                                <tr
                                    *ngIf="((currentUser.UserType == 1) && (studentDetails.PreviousLastName != null && studentDetails.PreviousLastName != ''))">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:183px;"
                                        translate>
                                        Previous Last Name
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <span>{{studentDetails.PreviousLastName}}</span>
                                    </td>
                                </tr>
                                <tr *ngIf="studentDetails.HomeDistrict">
                                    <td style="line-height:25px;vertical-align:top;color:#595959;width:183px;"
                                        translate>
                                        Home District
                                    </td>
                                    <td
                                        style="line-height: 25px; vertical-align: top; padding-left: 5px; padding-right:5px;">
                                        <span>{{studentDetails.HomeDistrict}}</span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </tr>
            </table>

            <div style="padding-bottom: 40px">
                <tr>
                    <td rowspan="5" colspan="2" style="line-height: 25px; vertical-align: top;">
                        <div style="padding-right: 50px;"
                            *ngIf="studentDetails.CurrentLocationCourse > '' || studentDetails.CurrentLocationSection > '' || studentDetails.CurrentLocationRoom > '' || studentDetails.CurrentLocationTeacher > ''">
                            <table style="border:2px solid #e8eaf6;">
                                <tr>
                                    <td colspan="2"
                                        style="line-height:25px;background-color:#e8eaf6;font-weight:bold;padding-left:2px;">
                                        <span style="color:#3f51b5" translate>Current Location</span>
                                    </td>
                                </tr>
                                <tr *ngIf="studentDetails.CurrentLocationCourse > ''">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Course
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.CurrentLocationCourse}}</td>
                                </tr>
                                <tr style="display:none;">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Section
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.CurrentLocationSection}}</td>
                                </tr>
                                <tr
                                    *ngIf="studentDetails.CurrentLocationRoom > '' || studentDetails.CurrentLocationCourse=='Student is between classes'">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Room
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.CurrentLocationRoom}}</td>
                                </tr>
                                <tr
                                    *ngIf="studentDetails.CurrentLocationTeacher > '' || studentDetails.CurrentLocationCourse=='Student is between classes'">
                                    <td style="line-height:normal;vertical-align:top;color:hsl(0, 0%, 35%);width:100px;padding-left:2px;"
                                        translate>
                                        Teacher
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.CurrentLocationTeacher}}</td>
                                </tr>
                            </table>
                        </div>
                    </td>
                    <td rowspan="5" colspan="2"
                        style="line-height: 25px; vertical-align: top; padding-left: 2px; padding-right: 5px;">
                        <div
                            *ngIf="studentDetails.HomeRoomCourse > '' || studentDetails.HomeRoomSection > '' || studentDetails.HomeRoomRoom > '' || studentDetails.HomeRoomTeacher > ''">
                            <table style="border:2px solid #e8eaf6;">
                                <tr>
                                    <td colspan="2"
                                        style="line-height:25px;background-color:#e8eaf6;font-weight:bold;padding-left:2px;">
                                        <span style="color:#3f51b5" translate>Home Room</span>
                                    </td>
                                </tr>
                                <tr *ngIf="studentDetails.HomeRoomCourse > ''">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Course
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.HomeRoomCourse}}</td>
                                </tr>
                                <tr style="display:none;">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Section
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.HomeRoomSection}}</td>
                                </tr>
                                <tr *ngIf="studentDetails.HomeRoomRoom > ''">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Room
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.HomeRoomRoom}}</td>
                                </tr>
                                <tr *ngIf="studentDetails.HomeRoomTeacher > ''">
                                    <td style="line-height:normal;vertical-align:top;color:#595959;width:100px;padding-left:2px;"
                                        translate>
                                        Teacher
                                    </td>
                                    <td style="line-height:normal;vertical-align:top;padding-right:5px;">
                                        {{studentDetails.HomeRoomTeacher}}</td>
                                </tr>
                            </table>
                        </div>
                    </td>
                </tr>
            </div>
        </div>
        <div *ngFor="let prntType of parentType; let i = index">
            <div *ngIf="prntType=='Parent' && hasParentContacts(prntType)" style="display: flex;">
                <b style="font-size: 12pt; color:#3f51b5;" translate>
                    Parent/Contact
                    Details
                </b>
            </div>
            <b style="font-size: 12pt; color:#3f51b5;" translate
                *ngIf="prntType=='Household' && hasParentContacts(prntType)">
                Household Parents/Guardians
            </b>
            <b style="font-size: 12pt; color:#3f51b5;" translate
                *ngIf="prntType=='Nonresident' && hasParentContacts(prntType)">
                Non-Resident
                Parents
            </b>
            <b style="font-size: 12pt; color:#3f51b5;" translate
                *ngIf="prntType=='Emergency' && hasParentContacts(prntType)">
                Emergency
                Contacts
            </b>

            <mat-table #table [dataSource]="getParentContactTableData(prntType)" multiTemplateDataRows matSort
                id="tblParentContacts" style="padding-bottom: 20px; outline: none;"
                aria-label="Parent Contacts Data Table" *ngIf="hasParentContacts(prntType)" tabindex="0">
                <ng-container matColumnDef="More">
                    <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;">
                        <span translate>More</span>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        style="min-width:68px;max-width:68px;text-align:center;color:black;">
                        <span aria-label="Expand row for more details">
                            <i [ngClass]="checkExpanded(contact) ?  'detail-row-expanded-icon' : 'detail-row-collapsed-icon'"
                                class="material-icons" aria-hidden="true"></i>
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PrimaryParent">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let contact;">
                        <span *ngIf="contact.Restricted == 'Yes'" style="font-weight: bold; color: red;">R</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="CallSequence">
                    <mat-header-cell *matHeaderCellDef></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index">
                        <span *ngIf="contact.EmergencyContact == 'Yes'">{{contact.EmergencyCallSequence}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Relationship">
                    <mat-header-cell *matHeaderCellDef><span translate>Relationship</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                        {{contact.Relationship}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef><span translate>Name</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                        {{contact.Name}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="EmergencyPhone">
                    <mat-header-cell *matHeaderCellDef><span translate>Emergency Phone</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                        <span>{{contact.EmergencyPhone}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Homephone">
                    <mat-header-cell *matHeaderCellDef><span translate>Home Phone</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                        {{contact.Homephone}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Cellphone">
                    <mat-header-cell *matHeaderCellDef><span translate>Cell Phone</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index"
                        [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                        {{contact.Cellphone}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="PortalAccess" *ngIf="currentUser.UserType == 1">
                    <mat-header-cell *matHeaderCellDef>
                        <div style="width:100%; text-align:center;" translate *ngIf="prntType!='Emergency'">
                            Portal Access
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index">
                        <div style="width:100%; text-align:center;" *ngIf="prntType!='Emergency'"
                            [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                            {{contact.PortalAccess ? 'Y' : 'N'}}
                        </div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="LastAccess" *ngIf="currentUser.UserType == 1">
                    <mat-header-cell *matHeaderCellDef><span translate *ngIf="prntType!='Emergency'"> Last Portal
                            Login</span></mat-header-cell>
                    <mat-cell *matCellDef="let contact; let j = index">
                        <span *ngIf="prntType!='Emergency'"
                            [ngClass]="{'boldRed': ((this.currentUser.UserType == 1) && (contact.ECLeaveWithThisPerson === 'No'))}">
                            {{contact.LastPortalAccess}}
                        </span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                    <td mat-cell class="mat-detail-card" *matCellDef="let contact" style="width:100%;">
                        <div class="detailRow"
                            style="margin-left: 50px; margin-right:10px; margin-bottom:10px;background-color:white; padding-top:5px; padding-bottom:5px; padding-left:10px;"
                            [attr.aria-label]="getAriaStudentDetail(contact)">
                            <div *ngIf="contact.EmergencyContact != 'Y'">
                                <!-- V9 block -->
                                <div>
                                    <div class="row">
                                        <div class="col">
                                            <div class="row" *ngIf="loginSettings.DisplayIsGuardian">
                                                <span class="label" translate>Is Guardian</span>
                                                <span translate>{{contact.IsGuardian}}</span>
                                            </div>
                                            <div class="row" *ngIf="loginSettings.DisplayCanPickup">
                                                <span
                                                    [ngClass]="{'boldRed': contact.CanPickUp == 'No' && currentUser.UserType == 1, 'label': contact.CanPickUp != 'No' || currentUser.UserType != 1}"
                                                    translate>Can Pick Up</span>
                                                <span
                                                    [ngClass]="{'boldRed': contact.CanPickUp == 'No' && currentUser.UserType == 1}"
                                                    translate>{{contact.CanPickUp}}</span>
                                            </div>
                                            <div class="row" *ngIf="this.currentUser.UserType == 1">
                                                <ng-container *ngIf="contact.ECLeaveWithThisPerson != 'No'">
                                                    <span class="label" translate>Student may leave with this
                                                        person?</span>
                                                    <span>{{contact.ECLeaveWithThisPerson}}</span>
                                                </ng-container>
                                                <span *ngIf="contact.ECLeaveWithThisPerson == 'No'"
                                                    style="font-weight: 600;color: red;">Student may NOT leave with this
                                                    person</span>
                                            </div>
                                            <div class="row" *ngIf="this.currentUser.UserType == 1">&nbsp;</div>
                                            <div class="row">
                                                <span class="label" translate>Email Address</span>
                                                <span *ngIf="this.currentUser.UserType == 1" style="color:#3f51b5"
                                                    (click)="sendEmail(contact.Name,contact.EmailAddress)"
                                                    class="link">{{contact.EmailAddress}}</span>
                                                <div *ngIf="this.currentUser.UserType != 1">
                                                    {{contact.EmailAddress}}
                                                </div>
                                            </div>
                                            <div></div>
                                            <div class="row">
                                                <span class="label" translate>Employer</span>
                                                <span translate>{{contact.PlaceOfWork}}</span>
                                            </div>
                                            <div class="row"
                                                *ngIf="contact.WorkPhone !='' && contact.WorkPhone != null">
                                                <span class="label" translate>Work Phone</span>
                                                <span translate>{{contact.WorkPhone}}</span>
                                            </div>
                                            <div class="row"
                                                *ngIf="contact.Homephone2 !='' && contact.Homephone2 != null">
                                                <span class="label" translate>Home Phone 2</span>
                                                <span translate>{{contact.Homephone2}}</span>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <span class="label" translate>Primary Address</span>
                                            <div style="padding-left: 16px;"
                                                [innerHTML]="contact.PrimaryAddress | safeHtml"></div>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col">
                                        </div>
                                        <div class="col" *ngIf="contact.ParentType == 'Household'">
                                            <span class="label" translate>Mailing Address</span>
                                            <span *ngIf="contact.MailingAddress == contact.PrimaryAddress"
                                                style="font-style: italic;padding-left: 16px;">
                                                Same as primary address
                                            </span>
                                            <div style="padding-left: 16px;"
                                                *ngIf="contact.MailingAddress != contact.PrimaryAddress"
                                                [innerHTML]="contact.MailingAddress | safeHtml">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <table style="width:100%" *ngIf="contact.EmergencyContact == 'Y'">
                                <tr>
                                    <td style="width:50%;line-height:normal;vertical-align:top;">
                                        <div>
                                            <table tabindex="0">
                                                <tr>
                                                    <td style="color: #595959; width: 230px; padding-right:5px;"
                                                        translate>
                                                        <span> Student may leave with this person?</span>
                                                    </td>
                                                    <td style="padding-right:5px;">{{contact.ECLeaveWithThisPerson}}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td style="color:#595959;width:230px;padding-right:5px;" translate>
                                                        Work
                                                        Phone
                                                    </td>
                                                    <td style="padding-right:5px;">{{contact.EmergencyPhone}}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                    <td style="width:50%;line-height:normal;vertical-align:top;">
                                        <div>
                                            <table>
                                                <tr tabindex="0">
                                                    <td style="color: #595959; width: 120px; padding-right:5px;"
                                                        translate>
                                                        Comment
                                                    </td>
                                                    <td rowspan="2" style="vertical-align:top;line-height:normal;">
                                                        {{contact.ECComments}}
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </td>
                                </tr>
                                <tr></tr>
                                <tr></tr>
                            </table>
                        </div>
                    </td>
                </ng-container>
                <mat-header-row *matHeaderRowDef="columnsToDisplay" id="contactsDataRow"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columnsToDisplay; let j = index;" id="contactsDataRow{{j}}"
                    tabindex="0" style="padding:0px;overflow: hidden;" matRipple class="element-row"
                    [cdkDetailRow]="row" [expandListener]="toggleAllRows" (click)="toggleMore(row); selectedRow = row"
                    [attr.aria-label]="getAriaDetailRow(row)"
                    [ngClass]="{ 'detailRowOpened': checkExpanded(row), 'selectedRow': selectedRow == row}">
                </mat-row>
                <mat-row matRipple class="mat-detail-row" *matRowDef="let row; columns: ['expandedDetail']"
                    [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"
                    (click)="selectedRow = row" [ngClass]="{'selectedRow': selectedRow == row}"></mat-row>
            </mat-table>
        </div>

        <div style="padding-bottom: 20px"
            *ngIf="studentDetails.StudentSiblings && studentDetails.StudentSiblings.length > 0">
            <b style="font-size: 12pt; color:#3f51b5;" *ngIf="studentDetails.StudentSiblings.length > 0"
                translate>Siblings</b>
            <mat-table #table [dataSource]="studentDetails.StudentSiblings" matSort id="tblStudentSiblings"
                aria-label="Parent Contacts Data Table" tabindex="0">
                <ng-container matColumnDef="Name">
                    <mat-header-cell *matHeaderCellDef><span translate>Name</span></mat-header-cell>
                    <mat-cell *matCellDef="let sibling; let j = index">
                        <a *ngIf="sibling.UserHasPermission && showSiblingLinks"
                            (click)="studentInformationClick(sibling.Id)">
                            {{sibling.Name}}
                        </a>
                        <span *ngIf="!sibling.UserHasPermission || !showSiblingLinks">{{sibling.Name}}</span>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="SchoolName">
                    <mat-header-cell *matHeaderCellDef><span translate>School</span></mat-header-cell>
                    <mat-cell *matCellDef="let sibling; let j = index">
                        {{sibling.SchoolName}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Grade">
                    <mat-header-cell *matHeaderCellDef><span translate>Grade</span></mat-header-cell>
                    <mat-cell *matCellDef="let sibling; let j = index">
                        {{sibling.Grade}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="Age">
                    <mat-header-cell *matHeaderCellDef><span translate>Age</span></mat-header-cell>
                    <mat-cell *matCellDef="let sibling; let j = index">
                        {{sibling.Age > 0 ? sibling.Age : ''}}
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="['Name','SchoolName','Grade','Age']"></mat-header-row>
                <mat-row *matRowDef="let row; columns: ['Name','SchoolName','Grade','Age']; let j = index;"
                    id="siblingDataRow{{j}}" tabindex="0" style="padding:0px;overflow: hidden;">
                </mat-row>
            </mat-table>
        </div>
        <div id="divStudentEnrollments">
            <b style="font-size: 12pt; color:#3f51b5;">
                <span translate>Enrollment History</span>
            </b>
            <mat-table #table [dataSource]="studentDetails.StudentEnrollments" matSort id="tblParentContacts"
                aria-label="Student Enrollment Data Table" tabindex="0">
                <ng-container matColumnDef="Year">
                    <mat-header-cell *matHeaderCellDef><span translate>Year</span></mat-header-cell>
                    <mat-cell *matCellDef="let enrollment; let j = index">
                        {{enrollment.Year}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="EntryDate">
                    <mat-header-cell *matHeaderCellDef><span translate>Entry</span></mat-header-cell>
                    <mat-cell *matCellDef="let enrollment; let j = index">
                        {{enrollment.EntryDate | date:'MM/dd/yy'}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="School">
                    <mat-header-cell *matHeaderCellDef><span translate>School</span></mat-header-cell>
                    <mat-cell *matCellDef="let enrollment; let j = index">
                        {{enrollment.School}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="GradeLevel">
                    <mat-header-cell *matHeaderCellDef><span translate>Grade Level</span></mat-header-cell>
                    <mat-cell *matCellDef="let enrollment; let j = index">
                        {{enrollment.GradeLevel}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="WithdrawalDate">
                    <mat-header-cell *matHeaderCellDef><span translate>Exit</span></mat-header-cell>
                    <mat-cell *matCellDef="let enrollment; let j = index">
                        <span
                            *ngIf="enrollment.WithdrawalDate != '0001-01-01T00:00:00'">{{enrollment.WithdrawalDate|date:'MM/dd/yy'}}</span>
                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef=" ['Year','EntryDate','School','GradeLevel','WithdrawalDate']">
                </mat-header-row>
                <mat-row
                    *matRowDef="let row; columns:  ['Year','EntryDate','School','GradeLevel','WithdrawalDate']; let j = index;"
                    id="enrollmentDataRow{{j}}" tabindex="0" style="padding:0px;overflow: hidden;"></mat-row>
            </mat-table>
        </div>
    </div>
</tyl-kendo-pdf-export>

<div class="flex-footer">
    <div class="flex-footer-left">
        <tyl-button image="Expand All.png" label="Expand All" (clickEvent)="expandAll(true)"></tyl-button>
        <tyl-button image="Collapse All.png" label="Collapse All" (clickEvent)="expandAll(false)"></tyl-button>
    </div>
</div>